<!-- <p>edit-sensor works!</p> -->
<app-dialog-header headerIcon="sensors" headerText="Modify {{dialogData.Name}} Sensor" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div class="frmcontainer">
		<div class="frmLeft">
			<div mat-dialog-content>
				<mat-form-field>
					<mat-label>Public Sensor ID:</mat-label>
					<input matInput readonly autocomplete="off" formControlName="PublicSensorID" required>
					<mat-error *ngIf="dialogForm.get('PublicSensorID')!.hasError('required')">
						<span>Public Sensor ID is required</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Name:</mat-label>
					<input matInput autocomplete="off" formControlName="Name" required>
					<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">
						<span>Sensor Name is required</span>
					</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>Description:</mat-label>
					<input matInput autocomplete="off" formControlName="Description">
					<mat-error *ngIf="dialogForm.get('Description')!.hasError('required')">
						<span>Description is required</span>
					</mat-error>
				</mat-form-field>
				<app-image-container [imgURL]="dialogForm.get('ImageSrc')?.value" 
							 [enablePicture]="enablePicture"
							 [enableCamera]="enableCamera"
							 [enableDelete]="enableDelete"
							 (onDelete)="deleteImg()" 
							 (onNewImage)="onNewImage($event)"></app-image-container>
				<div class="md-form mb-1 matFormSlider">
					<div>
						<mat-label>Enabled for Data Collection</mat-label>
						<mat-slide-toggle #switchEnabled formControlName="Enabled" color="primary"></mat-slide-toggle>
					</div>
				</div>
				<div class="md-form mb-1 matFormSlider">
					<div>
						<mat-label>Enabled Offline Notification</mat-label>
						<mat-slide-toggle #switchOfflineNotification formControlName="EnableOffline" color="primary"></mat-slide-toggle>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
